var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"like",class:{ active: _vm.isActive },on:{"click":_vm.changeFavorite}},[_c('span')])
}
var staticRenderFns = []

export { render, staticRenderFns }